module.exports = __webpack_public_path__ + "img/xiahua_00.f667c61a.svg";